import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Icon, Grid, Tooltip, Typography } from '@material-ui/core';
import ReactTable from "react-table";
import TableCellTooltip from '../TableCellTooltip';

const styles = theme => ({

});

class EventUsage extends React.Component {
    render() {
        const { event_usage } = this.props;

        const HtmlTooltip = withStyles((theme) => ({
            tooltip: {
                maxWidth: 250,
                fontSize: theme.typography.pxToRem(12),
                border: '1px solid #dadde9',
            },
        }))(Tooltip);

        return (
            <ReactTable
                columns={[
                    {
                        Header:   'Course Name',
                        accessor: 'CourseName',
                        Cell:     row => (
                            <TableCellTooltip
                                item={row.original.CourseName}
                                chars={20}
                            />
                        )
                    },
                    {
                        Header:   'Course Info',
                        accessor: 'CourseInfo',
                        Cell:     row => {
                            if (row.original.unscheduled) {
                                return 'Unscheduled';
                            } else {
                                return row.original.CourseStartDate + " - " + row.original.CourseEndDate;
                            }
                        }
                    },
                    {
                        Header:   'Lesson Name',
                        accessor: 'LessonName',
                        Cell:     row => (
                            <TableCellTooltip
                                item={row.original.LessonName}
                                chars={20}
                            />
                        )
                    },
                    {
                        Header:   'Event Date',
                        accessor: 'EventDate',
                        Cell:     row => {
                            if (row.original.unscheduled) {
                                return 'Unscheduled';
                            } else {
                                return row.original.EventDate;
                            }
                        }
                    },
                    {
                        Header:   'Student Info',
                        accessor: 'student_info',
                        Cell:     row => {
                            return (
                                <HtmlTooltip
                                    title={
                                        <Grid container spacing={0}>
                                            <Grid item xs={11}>Students Started/Completed Event:</Grid><Grid item xs={1}>{row.original.student_started_event_count}</Grid>
                                            <Grid item xs={11}>Students Completed Course:</Grid><Grid item xs={1}>{row.original.student_completed_course_count}</Grid>
                                            <Grid item xs={11}>Total Students in Course:</Grid><Grid item xs={1}>{row.original.course_student_count}</Grid>
                                        </Grid>
                                    }
                                >
                                    <Typography>{row.original.student_started_event_count + " / " + row.original.student_completed_course_count + " / " + row.original.course_student_count}</Typography>
                                </HtmlTooltip>
                            );
                        }
                    },
                    {
                        Header:   'Event Status',
                        accessor: 'event_status',
                        Cell:     row => {
                            const { 
                                is_in_conflict,
                                student_started_event_count,
                                course_student_count,
                                student_completed_course_count,
                                is_course_ended,
                            } = row.original;

                            let icon_color   = 'green';
                            let tooltip_list = [];

                            if (student_started_event_count === 0) {
                                tooltip_list.push(<p>No students have started this event.</p>);
                            }

                            if (student_completed_course_count === course_student_count && student_completed_course_count !== 0) {
                                tooltip_list.push(<p>All students have completed this course.</p>);
                            }

                            if (is_course_ended) {
                                tooltip_list.push(<p>Course has ended.</p>);
                            }

                            if (
                                student_started_event_count > 0
                                &&
                                (
                                    !(student_completed_course_count === course_student_count && student_completed_course_count !== 0)
                                    &&
                                    !is_course_ended
                                )
                            ) {
                                tooltip_list.push(<p>At least one student has started this event without finishing the course.</p>);
                                icon_color   = 'red';
                            }

                            return (
                                <HtmlTooltip title={<React.Fragment>{tooltip_list}</React.Fragment>}>
                                    <Icon style={{ color: icon_color }}>info</Icon>
                                </HtmlTooltip>
                            )
                        }
                    }
                ]}
                data={event_usage.event_list}
                defaultPageSize={25}
                className="-striped -highlight"
                noDataText="Event is not in use"
            />
        );
    }
}

export default withStyles(styles, { withTheme: true })(EventUsage);


// WEBPACK FOOTER //
// src/main/components/event/EventUsage.js